import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
} from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  tableCellClasses,
  Card,
  CardContent,
  FormGroup,
  IconButton,
  Alert,
  Stack,
  Switch,
  Chip,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { AsyncPaginate } from "react-select-async-paginate";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import FormPageHeader from "../../utilities/FormPageHeader";
import jwtDecode from "jwt-decode";
import OrderSuccess from "./OrderSuccess";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { styled, useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.primary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "5px 15px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",
  fontSize: "12px",

  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,

    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.action.disabledBackground,
    boxSizing: "border-box",
  },
}));



const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;
const newOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerOrder}`;
const uploadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadOrderFile}`;
const projectForeCastUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getProjectForecastData}`;
const projectUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getProjectByForecast}`;
const hubSpotDealsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getallhubspotdeals}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const deleteFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deleteFile}`;
const CreateAbsOrder = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { mode } = props;
  // const [activeStep, setActiveStep] = useState(0);
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [openSuccessOrder, setOpenSuccessOrder] = useState(false);
  const navigate = useNavigate();
  const [orderCategoryValue, setOrderCategoryValue] = useState();
  const [rowData, setRowData] = useState([]);
  const [phasesRowData, setPhasesRowData] = useState([]);
  const [typeRowData, setTypeRowData] = useState([]);

  const [gridApi, setGridApi] = useState(null);
  const [selectedProName, setSelectedProName] = useState(null);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedQty, setSelectedQty] = useState("");
  const [selectedPhases, setSelectedPhases] = useState("");
  const [showProjectTypeQty, setShowProjectTypeQty] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [formValues, setFormValues] = useState([
    {
      range: {},
      priceGroup: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);
  const [uploadValue, setUploadValue] = useState([{ uploadFile: null }]);
  const [range, setRange] = useState([]);
  const [color, setColor] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [handles, setHandles] = useState([]);
  const [carcass, setCarcass] = useState([]);
  const [error, setError] = useState();
  const [checksubmit, setCheckSubmit] = useState(false);
  const [validError, setValidError] = useState({});
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [customerId, setCustomerId] = useState();
  const [currentOrder, setCurrentOrder] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [showroom, setShowroom] = useState(null);
  const [hubspot, setHubspot] = useState();
  const [product, setProduct] = useState([]);
  const [category, setCategory] = useState();
  const [orderReference, setOrderReference] = useState("");
  const [typeNumber, setTypeNumber] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [clientName, setClientName] = useState("");
  const [commissionName, setCommissionName] = useState();
  const [WG1Price, setWG1Price] = useState("");
  const [WG2Price, setWG2Price] = useState("");
  const [totalWGPrice, setTotalWGPrice] = useState("");
  const [volume, setVolume] = useState();
  const [weight, setWeight] = useState();
  const [selectedRange, setSelectedRange] = useState({});
  const [selectedColor, setSelectedColor] = useState({});
  const [selectedCarcass, setSelectedCarcass] = useState({});
  const [selectedHandle, setSelectedHandle] = useState({});
  const [containerNo, setContainerNo] = useState();
  const [loadingWeek, setLoadingWeek] = useState();
  const [freight, setFreight] = useState();
  const [comment, setComment] = useState();
  const [discountChecked, setDiscountChecked] = useState(false);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [loadingWeekOptions, setLoadingWeekOptions] = useState([]);
  const [newOrderData, setNewOrderData] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [freightOptions, setFreightOptions] = useState([]);
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [hubSpot, setHubSpot] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [SDFile, setSDFile] = useState(null);
  const [DRWFile, setDRWFile] = useState(null);
  const [sdFileId, setSdFileId] = useState("");
  const [drwFileId, setDrwFileId] = useState("");
  const [appliancesDetailFileId, setAppliancesDetailFileId] = useState("");
  const [orderCheckFileId, setOrderCheckFileId] = useState("");
  const [drawingFileId, setDrawingFileId] = useState("");
  const [appliancesDetail, setAppliancesDetail] = useState(null);
  const [orderCheckFile, setOrderCheckFile] = useState(null);
  const [drawingFile, setDrawingFile] = useState(null);
  const [sharedLater, setSharedLater] = useState(false);
  const [notApplicable, setNotApplicable] = useState(false);
  const [drwFileSupersedes, setDrwFileSupersedes] = useState(false);
  const [productIdNull, setProductIdNull] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);
  const [projectForeCast, setProjectForeCast] = useState([]);
  const [foreCastProduct, setForeCastProduct] = useState(null);
  const [dealOptions, setDealOptions] = useState(null);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [selectedReferenceHubSpot, setSelectedReferenceHubSpot] = useState("");
  const [exitingProject, setExitingProject] = useState([]);
  const [deals, setDeals] = useState([]);
  const [costOfHubSpot, setCostOfHubSpot] = useState(0);
  const [hubSpotReference, setHubSpotReference] = useState("");
  const [defaultProductOption, setDefaultProductOption] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const hiddenDRWFile = useRef(null);
  const hiddenDicountFile = useRef(null);
  const hiddenADFile = useRef(null);
  const hiddenOrderCheckFile = useRef(null);
  const hiddenDrawingFile = useRef(null);
  const { absData, hasAbsData } = useSelector((state) => state.abs);
  const [shortKey, setShortKey] = useState();
  const [productKey, setProductKey] = useState();
  const [flag, setFlag] = useState(false);
  const [partnerName, setPartnerName] = useState("");
  const [selectedPartnerValue, setSelectedPartnerValue] = useState();
  const [loading, setLoading] = useState(false);
  const [lastEdited, setLastEdited] = useState(null)
  const [currentQuery, setCurrentQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const TOTAL_LENGTH = 21;
  const maxUniqueIdLength =
    TOTAL_LENGTH - clientName.length > 0 ? TOTAL_LENGTH - clientName.length : 0;

  const maxClientNameLength =
    TOTAL_LENGTH - uniqueID.length > 0 ? TOTAL_LENGTH - uniqueID.length : 0;
  const KEY_BACKSPACE = "Backspace";
  const KEY_F2 = "F2";
  const KEY_ENTER = "Enter";
  const KEY_TAB = "Tab";
  const regexPattern1 = /^[A-Z]{2}\d{6}-[A-Z]{2}-.*$/;
  const regexPattern2 = /^[A-Z]{2}\d{5}\d{3}[A-Z]{2}-.*$/;

  const hasSupperUser = [
    "ROLE_ADMIN",
    "ROLE_MD",
    "ROLE_ORDERPRO",
    "ROLE_SOPDIR",
  ].some((role) => {
    if (token) {
      return token.scope.includes(role);
    }
  });
  const getProductOptions=async()=>{
    let list;
    let newOrder = null;
    try {
      if (selectedPartnerValue) {
        list = await OAuthService.getList(
          newOrderUrl + `?customerId=${selectedPartnerValue}`
        );
        newOrder = list?.data;
      } else if (selectedPartner) {
        list = await OAuthService.getList(
          newOrderUrl + `?customerId=${selectedPartner?.value}`
        );
        newOrder = list?.data;
      }
 
          const products = newOrder?.products.map((value) => {
            return {
              label: value.name,
              value: value.shortKey,
              id: value.id,
            };
          });
          setProductOptions(products);
          setDefaultProductOption(products);
       
      
        } catch (error) {
      console.log("error.message", error);
      toast.error(error.message);
    }
  }
  const getNewOrder = async () => {
    let list;
    let newOrder = null;
    try {
      if (selectedPartnerValue) {
        list = await OAuthService.getList(
          newOrderUrl + `?customerId=${selectedPartnerValue}`
        );
        newOrder = list?.data;
      } else if (selectedPartner) {
        list = await OAuthService.getList(
          newOrderUrl + `?customerId=${selectedPartner?.value}`
        );
        newOrder = list?.data;
      }
      if (newOrder) {
        if (selectedPartner) {
          const products = newOrder?.products.map((value) => {
            return {
              label: value.name,
              value: value.shortKey,
              id: value.id,
            };
          });
          setProductOptions(products);
          setDefaultProductOption(products);
          setOrderReference(newOrder?.projectNum);
          setUniqueID(newOrder?.uniqueId === null ? "" : newOrder?.uniqueId);
          setClientName(newOrder?.clientName === null ? "" : newOrder?.clientName);
        }

        const loadingWeek = Object.keys(newOrder?.loadingWeek).map((key) => ({
          value: key,
          label: newOrder.loadingWeek[key],
        }));
        const showrooms = Object.keys(newOrder?.showrooms).map((key) => ({
          value: key,
          label: newOrder.showrooms[key],
        }));
        const filterOrderCategory = newOrder?.orderCategories.filter(
          (item) => item.name !== "PRJ" && item.name !== "CPRJ"
        );
        const orderCategories = filterOrderCategory.map((value) => {
          return { label: `${value.displayName}`, value: value.name };
        });
        const freight = newOrder?.freightOptions.map((value) => {
          return {
            label: `${value.shippingMethodName}`,
            value: value.shippingMethodName,
            id: value.code,
          };
        });
        setShowroom({
          value: newOrder?.showroomId,
          label: newOrder?.showroomName,
        });
        setFreightOptions(freight);
        setOrderCategoryOptions(orderCategories);
        setLoadingWeekOptions(loadingWeek);
        setShowroomOptions(showrooms);
        setCustomerName(newOrder?.companyName);
        setCustomerId(newOrder?.partnerCompany);
        setHubSpot(newOrder);
        setNewOrderData(newOrder);
        if (!flag) {
          setTypeNumber(newOrder?.typeNumber);
        }
      }
    } catch (error) {
      console.log("error.message", error);
      toast.error(error.message);
    }
  };
  const getDataFromCommissionName = (name) => {
    if (regexPattern1.test(name)) {
      const existingOrderRef = name.slice(0, 6);
      const existingTypeNumber = name.slice(6, 8);
      const remainingData = name.slice(8).split("-").filter(Boolean);

      setOrderReference(existingOrderRef);
      setShortKey(existingOrderRef.slice(0, 2));
      setTypeNumber(existingTypeNumber);
      setProductKey(remainingData[0]);
      setUniqueID(remainingData[1] || "");
      setClientName(remainingData.slice(2).join("-") || "");
    } else if (regexPattern2.test(name)) {
      const existingOrderRef = name.slice(0, 7);
      const existingTypeNumber = name.slice(7, 10);
      const productKey = name.slice(10, 12); // NK
      const remainingData = name.slice(12).split("-").filter(Boolean);

      setOrderReference(existingOrderRef);
      setShortKey(existingOrderRef.slice(0, 2));
      setTypeNumber(existingTypeNumber);
      setProductKey(productKey);
      setUniqueID(remainingData[0] || "");
      setClientName(remainingData.slice(1).join("-") || "");
    }
  };
  const findCompanyByShortKey = async (key) => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByShortKeyAndCustomerType?customerType=REGULAR&shortKey=${key}`;
    const result = await OAuthService.getList(url);
    const data = result.data;
    setPartnerName(data.id + "-" + data.shortKey + "-" + data.countryName);
    setSelectedPartnerValue(data?.id);
  };
  const findProductByShortKey = async (key) => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByShortKey?vendorShortKey=${key}`;
    const result = await OAuthService.getList(url);
    if (result.data) {
      setProduct({
        label: result.data.name,
        value: result.data.shortKey,
        id: result.data.id,
      });
    }
  };

  useEffect(() => {
    if (shortKey) findCompanyByShortKey(shortKey);
  }, [shortKey]);

  useEffect(() => {
    if (productKey) findProductByShortKey(productKey);
  }, [productKey]);
  useEffect(() => {
    if (selectedPartner || selectedPartnerValue || mode === "new") {
      getNewOrder();
    }
  }, [selectedPartner, selectedPartnerValue, mode]);

  const getInformationFromAbsData = (data) => {
    if (data?.wg1) {
      setWG1Price(data?.wg1);
    } else {
      setWG1Price("");
    }
    if (data?.wg2) {
      setWG2Price(data?.wg2);
    } else {
      setWG2Price("");
    }
    if (data?.volume) {
      setVolume(data?.volume);
    } else {
      setVolume("");
    }
    if (data?.weight) {
      setWeight(data?.weight);
    } else {
      setWeight("");
    }
  };
  useEffect(() => {
    const name = absData?.commissionName;

    if (regexPattern1.test(name) || regexPattern2.test(name)) {
      getDataFromCommissionName(name);
      setFlag(true);
    } else {
      getNewOrder();
    }

    getInformationFromAbsData(absData);
  }, [absData, mode]);
  // For projects the  the API is updated if the commission name exist --todo
  const getProjectForeCastList = async () => {
    OAuthService.getList(
      `${projectForeCastUrl}?companyId=${hasSupperUser ? selectedPartner?.value : customerId
      }`
    )
      .then((list) => {
        const data = list.data;
        if (data) {
          setProjectForeCast(data);
          setProjectOptions(
            data.map((item) => ({
              value: item.overallQty,
              label: item.projectName,
              id: item.id,
            }))
          );
        }
      })
      .catch((err) => toast.error(err.message));
  };

  const getProject = async () => {
    try {
      const list = await OAuthService.getList(
        `${projectUrl}?forecastId=${selectedProName.id}`
      );
      if (list.status === 200) {
        setExitingProject(list.data);
        setCount(list?.data?.types.length);
      } else {
        setExitingProject([]);
        setCount(0);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
        error?.response?.data ||
        error.message
      );
    }
  };

  const getCustomer = async () => {
    const list = await OAuthService.getList(
      companiesUrl +
      `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`
    );
    let companies = list.data?._embedded?.companies;
    companies = companies.map((company) => {
      return {
        value: company.id,
        label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
      };
    });
    setCustomerOptions(companies);
    if (customerId) {
      const defaultCustomer = companies.find((item) => item.id === customerId);
      // console.log('defaultCustomer', customerId, defaultCustomer)
      setCustomerName(defaultCustomer);
    }
  };


  const getRangeList = async () => {
    OAuthService.getList(`${rangeUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const ranges = list.data;
        setRange(
          ranges?.map((range) => ({
            value: range?.productId,
            label: `${range?.priceGroup?.pgId || "NA"}-${range?.productName}`,
            id: range.id,
            priceGroup: range?.priceGroup?.pgId,
          }))
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getHandleList = async () => {
    OAuthService.getList(`${handleUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { handles } = list.data?._embedded;
        setHandles(
          handles?.map((handle) => ({
            value: handle.productId,
            label: `${handle.productId}-${handle.productName}`,
          }))
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getCarcassList = async () => {
    OAuthService.getList(`${carcassUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { carcasses } = list.data?._embedded;
        setCarcass(
          carcasses?.map((carcasse) => ({
            value: carcasse.productId,
            label: `${carcasse.productId}-${carcasse.productName}`,
          }))
        );
      })
      .catch((err) => toast.error(err.message));
  };

  useEffect(() => {
    if (orderReference && typeNumber) {
      setCommissionName(
        (`${orderReference}${typeNumber}-${product?.value === undefined ? "" : product?.value
          }-${uniqueID}-${clientName}`).toUpperCase()
      );
    }
  }, [orderReference, typeNumber, product, uniqueID, clientName]);



  useEffect(() => {
    if (selectedProName) {
      getProject();
    }
  }, [selectedProName]);

  useEffect(() => {
    if (
      orderCategoryValue?.value === "PRJ" ||
      orderCategoryValue?.value === "CPRJ"
    ) {
      if (customerName.value || customerId) {
        getProjectForeCastList();
      }
    }
  }, [orderCategoryValue, customerName, customerId]);

  useEffect(() => {
    if (product?.id) {
      getRangeList();
      getHandleList();
      getCarcassList();
    }
  }, [product]);

  useEffect(() => {
    if (mode === "new") {
      setOrderCategoryValue();
      setContainerNo("");
      setLoadingWeek();
      setFreight();
      setComment("");
      setSDFile("");
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
    }
  }, [mode === "new"]);

  
 
  const handleChangeOrderCategory = (event) => {
    setOrderCategoryValue({
      value: event.value,
      label: event.label,
    });
    // setProduct(null);
    // setProductOptions(defaultProductOption);
    if (event.value === "RET") {
      setSelectedDeal(null);
    }
    if (event.value === "PRJ" || event.value === "CPRJ") {
      setOpen(true);
    }
    if (event.value === "CPRJ") {
      // setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setRowData([]);
      setDisplayName("");
    }
  };

  const placeOrder = () => {
    return (
      <>
        
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={
              btnDisable || clientName.length < 1 ||
              uniqueID.length < 1 ||
              clientName.length + uniqueID.length > 21 || loading
            }
             color="secondary"
          >
            Place Order
          </Button>
      </>
    );
  };

  let addFormFields = () => {
    if (formValues.length < 3) {
      setFormValues([
        ...formValues,
        { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
      ]);
    }
  };

  let addUploadFields = () => {
    setUploadValue([...uploadValue, { id: "", uploadFile: null }]);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  let removeUploadFields = (i) => {
    let newUploadValue = [...uploadValue];
    newUploadValue.splice(i, 1);
    setUploadValue(newUploadValue);
  };



  const steps = rowData;
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (activeStep) {
      const typeName = steps[activeStep]?.typeName;
      const typeNum = (count + 1).toString().padStart(3, "0");
      if (typeName) {
        const value = steps[activeStep].qty;
        const newRow = [];
        for (let i = 0; i < value; i++) {
          newRow.push({
            typeNum,
            typeName,
            uniqId: "",
            commisionName: "",
          });
        }
        setTypeRowData(newRow);
        setOpen(false);
        setShowProjectTypeQty(true);
      }
    }
  }, [activeStep, steps]);

  const handleSubmit = async () => {
    setCheckSubmit(true);
    setLoading(true);
    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value.label;
        } else {
          result[`${prefix}Id`] = value.value;
          result[prefix] = value.label;
        }
      });
      return result;
    });
    const resultObject = materialFormData.reduce(
      (accumulator, currentObject, index) => {
        Object.entries(currentObject).forEach(([key, value]) => {
          accumulator[key] = value;
        });
        return accumulator;
      },
      {}
    );

    const temp = uploadValue[0].uploadFile ? uploadValue.map((i) => i.id) : [];
    const customerNamePayload = flag
      ? selectedPartnerValue
      : selectedPartner?.value;
    const payload = {
      ...resultObject,
      customerId: customerNamePayload,
      companyId: customerNamePayload,
      showroomId: showroom.value,
      orderCategory: orderCategoryValue?.value,
      docType: "SO",
      newOrder: mode === "new-type" ? false : true,
      containerNo: containerNo?.toUpperCase(),
      freightId: freight.id,
      freight: freight.value,
      wg1: WG1Price,
      wg2: WG2Price,
      volume: volume,
      weight: weight,
      vendorId: product.id,
      vendor: product.label,
      projectTypeNum: Number(typeNumber),
      projectUniqueId: uniqueID?.toUpperCase(),
      projectClient: clientName?.toUpperCase(),
      commissionName: commissionName,
      orderRef: orderReference,
      specialComments: comment?.toUpperCase(),
      loadingWeek: loadingWeek.value,
      // vendorShortKey: product.value,
      typeName: typeNumber,
      sharedLater: sharedLater,
      na: notApplicable,
      drawFileSupersedes: drwFileSupersedes,
      isSpecialDiscount: discountChecked,
      drwFile: drwFileId,
      applianceDetail: appliancesDetailFileId,
      orderCheckList: orderCheckFileId,
      // drawingFile: firstFileId,
      orderFiles: temp,
      specialDiscountFile: sdFileId,
      customerProjectNum: 0,
      hubspotReference: hubSpotReference,
      hubspotDealAmount: costOfHubSpot,
      abFileId: absData?.id,
    };
    try {
      await OAuthService.addData(newOrderUrl, payload).then((list) => {
        const data = list.data;
        setCurrentOrder(data);
        if (flag) {
          setFlag(false);
        }
      });
      setOpenSuccessOrder(true);
      setCheckSubmit(false);
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      setLoading(false);
      return;
    }
  };

  const handleRangeChange = (data, index, field) => {
    const newVals = formValues; //[index];
    newVals[index][field] = { value: data.value, label: data.label }; // data.value;
    setSelectedRange({ value: data.value, label: data.label, id: data.id });
    if (field === "range") {
      newVals[index]["color"] = {}; // data.value;
      newVals[index]["priceGroup"] = {
        value: data.priceGroup,
        label: data.priceGroup,
      };
      OAuthService.getList(`${colorUrl}/${data.id}/variations`)
        .then((list) => {
          const rangeVariations = list.data?._embedded?.rangeVariations;
          const colors = color;
          colors[index] = rangeVariations?.map((variations) => ({
            value: variations.productId,
            label: `${variations.productId}-${variations.productName}`,
          }));
          setColor((prev) => [...colors]);
        })
        .catch((err) => toast.error(err.message));
    }
    setFormValues((prev) => [...newVals]);
  };

  const resetFormValues = () => {
    const set = [];
    formValues.map(() => {
      set.push({ range: {}, color: {}, carcass: {}, handle: {} });
    });
    setFormValues(() => [...set]);
  };
  const handleSpecialDicount = (event) => {
    setDiscountChecked(event.target.checked);
  };

  const filterLoadingWeekOptions = loadingWeekOptions.map((option, index) => ({
    ...option,
    isDisabled: sharedLater && index === 1,
  }));

  const [key, setKey] = useState(0);

  const removeSDFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, sdFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenDicountFile.current.value = null;
      setSDFile(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeDRWFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drwFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenDRWFile.current.value = null;
      setDRWFile(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeADFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, appliancesDetailFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenADFile.current.value = null;
      setAppliancesDetail(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeOrderCheckFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, orderCheckFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenOrderCheckFile.current.value = null;
      setOrderCheckFile(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeDrawingFile = async (index) => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drawingFileId[index]);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenDrawingFile.current.value = null;
      setDrawingFile(null);
      const filteredFiles = uploadValue;
      filteredFiles[index] = { id: "", uploadFile: {} };
      setUploadValue(() => [...filteredFiles]);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleSDUpload = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    const payload = {
      file: [fileUploaded],
      customerId: flag ? selectedPartnerValue : selectedPartner?.value,
      commissionName: commissionName,
      isOriginal: true,
    };
    OAuthService.addFiles(`${uploadOrderFileUrl}`, payload).then((list) => {
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setSdFileId(fileId.join(""));
    });
    setSDFile(fileUploaded);
    const formData = new FormData();
    formData.append("File", SDFile);
    setKey((prevKey) => prevKey + 1);
  };
  const handleDRWUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    const fileExtension = fileUploaded.name.split(".").pop().toLowerCase();
    if (fileExtension !== "drw" && fileExtension !== "prw") {
      toast.warning("Please upload a file with .drw or .prw extension");
      return;
    }
    try {
      const payload = {
        file: [fileUploaded],
        customerId: flag ? selectedPartnerValue : selectedPartner?.value,
        commissionName: commissionName,
        isOriginal: true,
      };
      const list = await OAuthService.addFiles(`${uploadOrderFileUrl}`, payload)
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setDrwFileId(fileId.join(""));

      setDRWFile(fileUploaded);
      const formData = new FormData();
      formData.append("File", DRWFile);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
        error?.response?.data ||
        error.message
      );
    }
  };
  const handleADUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    try {


      const payload = {
        file: [fileUploaded],
        customerId: flag ? selectedPartnerValue : selectedPartner?.value,
        commissionName: commissionName,
        isOriginal: true,
      };
      const list = await OAuthService.addFiles(`${uploadOrderFileUrl}`, payload)
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setAppliancesDetailFileId(fileId.join(""));

      setAppliancesDetail(fileUploaded);
      const formData = new FormData();
      formData.append("File", appliancesDetail);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
        error?.response?.data ||
        error.message
      );
    }
  };
  const handleOrderCheckUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    try {

      const payload = {
        file: [fileUploaded],
        customerId: flag ? selectedPartnerValue : selectedPartner?.value,
        commissionName: commissionName,
        isOriginal: true,
      };
      const list = await OAuthService.addFiles(`${uploadOrderFileUrl}`, payload)
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setOrderCheckFileId(fileId.join(""));

      setOrderCheckFile(fileUploaded);
      const formData = new FormData();
      formData.append("File", orderCheckFile);
      setKey((prevKey) => prevKey + 1);

    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
        error?.response?.data ||
        error.message
      );
    }
  };
  const handleDrawingUpload = (e, index) => {
    const newUploadValue = [...uploadValue];
    newUploadValue[index].uploadFile = e.target.files[0];
    if (!newUploadValue) return;
    const payload = {
      file: e.target.files[0],
      customerId: flag ? selectedPartnerValue : selectedPartner?.value,
      commissionName: commissionName,
      isOriginal: true,
    };
    OAuthService.addFiles(`${uploadOrderFileUrl}`, payload).then((list) => {
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setDrawingFileId((prevIds) => [...prevIds, fileId.join("")]);
      newUploadValue[index].id = data.map((file) => file.id)[0]; // e.target.files[0];
      setUploadValue(() => [...newUploadValue]);
      setKey((prevKey) => prevKey + 1);
    }).catch((err) => toast.error(err?.response?.data?.errorMessage ||
      err?.response?.data ||
      err?.message));
  };

  const handleUniqueIDChange = (e) => {
    const rawValue = e.target.value;
    const validationValue = rawValue.toUpperCase();

    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      toast.warn("Special characters are not allowed!");
      return;
    }

    const hasForwardSlash = validationValue.includes("/");
    const hasBackwardSlash = validationValue.includes("\\");
    if (hasForwardSlash || hasBackwardSlash) {
      let errorMessage = "Unique ID must not contain";
      if (hasForwardSlash) errorMessage += " '/'.";
      if (hasBackwardSlash) errorMessage += " '\\'.";
      toast.warn(errorMessage);
      return;
    }

    setUniqueID(rawValue);
    setLastEdited("uniqueID");
  };

  const handleClientNameChange = (e) => {
    const rawValue = e.target.value;
    const validationValue = rawValue.toUpperCase();
    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      toast.warn("Special characters are not allowed!");
      return;
    }

    const hasForwardSlash = validationValue.includes("/");
    const hasBackwardSlash = validationValue.includes("\\");
    if (hasForwardSlash || hasBackwardSlash) {
      let errorMessage = "Client Name must not contain";
      if (hasForwardSlash) errorMessage += " '/'.";
      if (hasBackwardSlash) errorMessage += " '\\'.";
      toast.warn(errorMessage);
      return;
    }

    setClientName(rawValue);
    setLastEdited("clientName");
  };


  const totalListPrice = () => {
    const number1 = parseFloat(WG1Price) || 0;
    const number2 = parseFloat(WG2Price) || 0;
    const sum = number1 + number2;
    return sum
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,")
      .toLocaleString("en-US", {
        minimumFractionDigits: 2,
      });
  };

  useEffect(() => {
    if (sharedLater) {
      setLoadingWeek({ value: "ONHOLD", label: "On Hold" });
    }
  }, [sharedLater]);

 
  const isValid = useMemo(() => {
    let isCategoryValid = true;
    if (orderCategoryValue?.value !== "PRJ") {
      
      isCategoryValid = !!(
        showroom?.label &&
        product &&
        orderCategoryValue &&
        uniqueID &&
        clientName &&
        WG1Price &&
        WG2Price &&
        volume &&
        loadingWeek &&
        freight &&
        !!DRWFile &&
        (!!appliancesDetail || sharedLater || notApplicable) &&
        (!!orderCheckFile || drwFileSupersedes) &&
        (!discountChecked || (discountChecked && SDFile)) &&
        formValues.every((value) =>
          Object.values(value).every(
            (field) => field && Object.keys(field).length > 0
          )
        )
      );
    } else {
      isCategoryValid = !!(
        showroom?.label  &&
        product &&
        orderCategoryValue &&
        WG1Price &&
        WG2Price &&
        volume &&
        loadingWeek &&
        freight &&
        !!DRWFile &&
        (!!appliancesDetail || sharedLater || notApplicable) &&
        (!!orderCheckFile || drwFileSupersedes) &&
        formValues.every((value) =>
          Object.values(value).every(
            (field) => field && Object.keys(field).length > 0
          )
        ) &&
        typeRowData.every(
          (row) => row.uniqId !== undefined && row.uniqId !== ""
        )
      );
    }
    return isCategoryValid;
  }, [
    showroom,
    product,
    orderCategoryValue,
    uniqueID,
    clientName,
    WG1Price,
    WG2Price,
    volume,
    loadingWeek,
    freight,
    DRWFile,
    appliancesDetail,
    orderCheckFile,
    drwFileSupersedes,
    sharedLater,
    notApplicable,
    formValues,
    typeRowData,
    discountChecked,
    SDFile,
  ]);

  useEffect(() => {
    setBtnDisable(!isValid);
  }, [isValid]);
;

 
  useEffect(() => {
    if (
      orderCategoryValue?.value === "PRJ" &&
      product &&
      exitingProject.length > 0
    ) {
      setOrderReference(exitingProject.project);
    }
  }, [orderCategoryValue, product, exitingProject]);
  const getHubSpotDeal = async (query, page) => {
    const size = 20;
    if (query !== currentQuery) {
      setCurrentPage(0);
      setCurrentQuery(query);
    }
    try {
      let url = `${hubSpotDealsUrl}/${customerId}`;
      if (query) {
        url += `?query=${query}&after=${page}`;
      } else if (page !== undefined) {
        url += `?after=${page}`;
      }
      const list = await OAuthService.getList(url);
      const results = list.data?.results;
      let getDeals = results.map((item) => item.properties);

      // Product already known (commission name parsed) -> only show deals for that product
      if (flag && product?.label) {
        getDeals = getDeals.filter((item) => {
          const dealProducts = item.product_group_quoted__test_
            ?.split(";")
            .map((p) => p?.toUpperCase()?.replace("KITCHEN", "KUECHEN"));
          return dealProducts?.includes(product.label?.toUpperCase());
        });
      }

      setDeals(getDeals);
      setDealOptions(
        getDeals.map((item) => ({
          value: item.hs_object_id,
          label: item.dealname,
          referenceNumber: item.reference_number,
          final_amount_eco: item.final_amount_eco,
          final_amount_ek: item.final_amount_ek,
          final_amount_neo: item.final_amount_neo,
          final_amount_nk: item.final_amount_nk,
          final_amount_spa: item.final_amount_spa,
        })),
      );
      return {
        options: getDeals,
        hasMore: list.data?.paging?.next?.after > 0 ? true : false,
        additional: { page: list.data?.paging?.next?.after },
      };
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const handleMainProductChange = (event) => {
    setProduct({
      value: event.value,
      label: event.label,
      id: event.id,
    });
    resetFormValues();
    if (event.id == 60001) {
      setCostOfHubSpot(selectedDeal?.final_amount_nk || 0);
    } else if (event.id == 60002) {
      setCostOfHubSpot(selectedDeal?.final_amount_ek || 0);
    } else if (event.id == 60006) {
      setCostOfHubSpot(selectedDeal?.final_amount_eco || 0);
    } else if (event.id == 60009) {
      setCostOfHubSpot(selectedDeal?.final_amount_neo || 0);
    } else if (event.id == 60008) {
      setCostOfHubSpot(selectedDeal?.final_amount_spa || 0);
    }
  };
const handleDealNameChange = (event) => {
  setSelectedDeal(event);
  setHubSpotReference(event.reference_number);

  if (flag && product?.label) {
    const costByProductId = {
      60001: event.final_amount_nk,
      60002: event.final_amount_ek,
      60006: event.final_amount_eco,
      60009: event.final_amount_neo,
      60008: event.final_amount_spa,
    };
    setCostOfHubSpot(costByProductId[product.id] || 0);
    return;
  }

  setProductOptions(defaultProductOption);
  const getDealProducts = event?.product_group_quoted__test_?.split(";");
  const dealUpperCase = getDealProducts?.map((item) => item?.toUpperCase());
  const changeWord = dealUpperCase?.map((item) =>
    item?.replace("KITCHEN", "KUECHEN"),
  );
  const filterProduct = defaultProductOption?.filter((item) =>
    changeWord?.includes(item?.label),
  );
  setProductOptions(filterProduct);
  setProduct([]);
  setCostOfHubSpot(0);
};
  
  useEffect(() => {
    if (hasSupperUser) {
      getCustomer();
    }
  }, [hasSupperUser]);
  useEffect(() => {
  if (
    flag &&
    product?.label &&
    orderCategoryValue?.value === "RET" &&
    newOrderData.hubspotEnabled
  ) {
    getHubSpotDeal();
  }
}, [flag, product, orderCategoryValue, newOrderData]);
  return (
    <>
      <FormPageHeader
        componentName="Create Order"
        pageName="Create Order"
        currentPage={`Create Order - AB # ${absData?.abNumber}`}
        orderHeaderAction={placeOrder()}
        successMsg={successMsg}
        snackState={snackState}
        error={error}
      ></FormPageHeader>
      <div className="px-12 md:px-20">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey", borderRadius: 4 }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Partner</label>
                  {flag ? (
                    <TextField
                      name="customer"
                      fullWidth
                      variant="outlined"
                      type="text"
                      value={partnerName}
                      disabled
                    />
                  ) : (
                    <Select
                      placeholder={"Select Partner"}
                      name="partner"
                      value={selectedPartner}
                      options={customerOptions}
                      onChange={(event) => {
                        setSelectedPartner({
                          value: event.value,
                          label: event.label,
                        });
                        setShowroom(null);
                        setOrderCategoryValue(null);
                        setSelectedProName(null);
                        setProduct(null);
                        setSelectedPhases("");
                        setSelectedQty("");
                        setPhasesRowData([]);
                        setRowData([]);
                        setDisplayName("");
                      }}
                      styles={customStyles()}
                      className="select"
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Showroom</label>
                  <Select
                    value={showroom}
                    onChange={(event) =>
                      setShowroom({ value: event.value, label: event.label })
                    }
                    name="showroom"
                    options={showroomOptions}
                    styles={customStyles(
                      ((checksubmit && !showroom) || validError.showroom) &&
                        "#f44336",
                    )}
                    className="select"
                    isDisabled={mode === "new-type"}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !showroom
                      ? "This field is required"
                      : validError.showroom}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            {orderCategoryValue?.value !== "PRJ" &&
              orderCategoryValue?.value !== "CPRJ" && (
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey", borderRadius: 4 }}
                >
                  <Grid container xs={12} spacing={2} className="mb-16">
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Type Number</label>
                      <TextField
                        value={typeNumber}
                        name="typeNumber"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Unique ID</label>

                      <TextField
                        name="uniqueID"
                        value={uniqueID}
                        onChange={handleUniqueIDChange}
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{
                          maxLength: maxUniqueIdLength,
                          style: { textTransform: "uppercase" },
                        }}
                        error={
                          lastEdited === "uniqueID" &&
                          uniqueID.length + clientName.length > 20
                        }
                        helperText={
                          lastEdited === "uniqueID" &&
                          uniqueID.length + clientName.length > 20 &&
                          `Total characters (Client Name + Unique ID) must be 21 or less`
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Client Name</label>

                      <TextField
                        value={clientName}
                        onChange={handleClientNameChange}
                        name="clientName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{
                          maxLength: maxClientNameLength,
                          style: { textTransform: "uppercase" },
                        }}
                        error={
                          lastEdited === "clientName" &&
                          uniqueID.length + clientName.length > 20
                        }
                        helperText={
                          lastEdited === "clientName" &&
                          uniqueID.length + clientName.length > 20 &&
                          `Total characters (Client Name + Unique ID) must be 21 or less`
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert
                        severity="info"
                        sx={{
                          fontSize: "12px",
                          padding: 0,
                          background: "none",
                          "& .MuiAlert-icon": {
                            padding: 0,
                          },
                          "& .MuiAlert-message": {
                            padding: "2px 0px",
                          },
                        }}
                      >
                        Note: The Commission Name will be combination of Unique
                        ID & Client Name
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <label className="pb-8 block">Commission Name</label>
                      <TextField
                        value={commissionName}
                        name="commissionName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey", borderRadius: 4 }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Volume(cbm)</label>
                  {absData?.volume ? (
                    <TextField
                      value={volume}
                      name="volume"
                      fullWidth
                      variant="outlined"
                      type="text"
                      disabled
                    />
                  ) : (
                    <TextField
                      value={volume}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(
                          /[^\d.]/g,
                          "",
                        );
                        setVolume(inputValue);
                      }}
                      name="volume"
                      fullWidth
                      variant="outlined"
                      type="text"
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">Weight (kg)</label>
                  {absData?.weight ? (
                    <TextField
                      value={weight}
                      name="weight"
                      fullWidth
                      variant="outlined"
                      type="text"
                      disabled
                    />
                  ) : (
                    <TextField
                      value={weight}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(
                          /[^\d.]/g,
                          "",
                        );
                        setWeight(inputValue);
                      }}
                      name="volume"
                      fullWidth
                      variant="outlined"
                      type="text"
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
            <Box
              className="shadow mb-20 mt-20"
              style={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
              }}
              sx={{
                // backgroundColor: "#2A2E32",
                p: 2,
                position: "relative",
                borderRadius: "1.6rem",
                borderBottomRightRadius: 0,
                mb: 2.5,
                width: "100%",
              }}
            >
              {formValues.map((element, index) => (
                <>
                  <Grid
                    container
                    xs={12}
                    spacing={2}
                    className={index ? "mt-4 relative" : "relative"}
                  >
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 flex">*Range</label>
                      <Select
                        value={formValues?.[index]?.range}
                        onChange={(e) => handleRangeChange(e, index, "range")}
                        name="range"
                        options={range}
                        styles={customStyles(
                          ((checksubmit && !selectedRange) ||
                            validError.selectedRange) &&
                            "#f44336",
                        )}
                        className="w-full"
                      />
                      <Typography className="text-[#f44336] text-sm ml-14">
                        {checksubmit && !selectedRange
                          ? "This field is required"
                          : validError.selectedRange}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 flex">*Color</label>
                      <Select
                        value={formValues?.[index]?.color}
                        onChange={(e) => handleRangeChange(e, index, "color")}
                        name="color"
                        options={color[index]}
                        styles={customStyles(
                          ((checksubmit && !selectedColor) ||
                            validError.selectedColor) &&
                            "#f44336",
                        )}
                        className="w-full"
                      />
                      <Typography className="text-[#f44336] text-sm ml-14">
                        {checksubmit && !selectedColor
                          ? "This field is required"
                          : validError.selectedColor}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 flex">*Carcass</label>
                      <Select
                        value={formValues?.[index]?.carcass}
                        onChange={(e) => handleRangeChange(e, index, "carcass")}
                        name="carcass"
                        options={carcass}
                        styles={customStyles(
                          ((checksubmit && !selectedCarcass) ||
                            validError.selectedCarcass) &&
                            "#f44336",
                        )}
                        className="w-full"
                      />
                      <Typography className="text-[#f44336] text-sm ml-14">
                        {checksubmit && !selectedCarcass
                          ? "This field is required"
                          : validError.selectedCarcass}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 flex">*Handle</label>
                      <Select
                        value={formValues?.[index]?.handle}
                        onChange={(e) => handleRangeChange(e, index, "handle")}
                        name="handle"
                        options={handles}
                        styles={customStyles(
                          ((checksubmit && !selectedHandle) ||
                            validError.selectedHandle) &&
                            "#f44336",
                        )}
                        className="w-full"
                      />
                      <Typography className="text-[#f44336] text-sm ml-14">
                        {checksubmit && !selectedHandle
                          ? "This field is required"
                          : validError.selectedHandle}
                      </Typography>
                    </Grid>
                    {index ? (
                      <IconButton
                        color="secondary"
                        onClick={() => removeFormFields(index)}
                        sx={{
                          position: "absolute",
                          right: { xs: 0, md: "-30px" },
                          top: { xs: 0, md: "auto" },
                          bottom: { xs: "auto", md: 4 },
                        }}
                      >
                        <FuseSvgIcon size={14}>heroicons-outline:x</FuseSvgIcon>
                      </IconButton>
                    ) : null}
                  </Grid>
                </>
              ))}
              {formValues.length < 3 && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => addFormFields()}
                  size="small"
                  sx={{
                    position: "absolute",
                    bottom: "-32px",
                    right: 0,
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                  }}
                >
                  <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
                </Button>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey", borderRadius: 4 }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={
                    orderCategoryValue?.value === "RET" &&
                    newOrderData.hubspotEnabled
                      ? 3
                      : 4
                  }
                >
                  <label className="pb-8 block">*Order Category</label>
                  <Select
                    value={orderCategoryValue}
                    options={orderCategoryOptions}
                    styles={customStyles(
                      ((checksubmit && !orderCategoryValue) ||
                        validError.orderCategoryValue) &&
                        "#f44336",
                    )}
                    className="w-full"
                    onChange={handleChangeOrderCategory}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !orderCategoryValue
                      ? "This field is required"
                      : validError.orderCategoryValue}
                  </Typography>
                </Grid>
                {orderCategoryValue?.value === "RET" &&
                  newOrderData.hubspotEnabled && (
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 block">*Hubspot Deal</label>
                      <AsyncPaginate
                        value={selectedDeal}
                        loadOptions={(inputValue, _, { page }) =>
                          getHubSpotDeal(inputValue, page)
                        }
                        getOptionValue={(option) => option.hs_object_id}
                        getOptionLabel={(option) => option.dealname}
                        onChange={handleDealNameChange}
                        styles={customStyles()}
                        className="w-full"
                        isSearchable
                        isDisabled={mode === "edit"}
                        additional={{
                          page: currentPage,
                        }}
                      />
                    </Grid>
                  )}
                {orderCategoryValue?.value !== "PRJ" &&
                  orderCategoryValue?.value !== "CPRJ" && (
                    <Grid
                      item
                      xs={
                        orderCategoryValue?.value === "RET" &&
                        newOrderData.hubspotEnabled
                          ? 3
                          : 4
                      }
                    >
                      <label className="pb-8 block">*Product</label>
                      {flag ? (
                        <TextField
                          name="product"
                          fullWidth
                          variant="outlined"
                          type="text"
                          value={product?.label}
                          disabled
                        />
                      ) : (
                        <Select
                          value={product}
                          onChange={handleMainProductChange}
                          name="product"
                          options={productOptions}
                          styles={customStyles(
                            ((checksubmit && !product) || validError.product) &&
                              "#f44336",
                          )}
                          className="w-full"
                        />
                      )}

                      <Typography className="text-[#f44336] text-sm ml-14">
                        {checksubmit && !product
                          ? "This field is required"
                          : validError.product}
                      </Typography>
                    </Grid>
                  )}
                <Grid
                  item
                  xs={
                    orderCategoryValue?.value === "RET" &&
                    newOrderData.hubspotEnabled
                      ? 3
                      : 4
                  }
                >
                  <label className="pb-8 block">Order Reference</label>
                  <TextField
                    value={orderReference}
                    name="orderReference"
                    fullWidth
                    variant="outlined"
                    type="text"
                    disabled
                  />
                </Grid>

                {orderCategoryValue?.value === "RET" &&
                  newOrderData.hubspotEnabled &&
                  selectedDeal && (
                    <>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            textAlign: "center",
                            borderRadius: "4px",
                            background: "rgb(255, 255, 255, 0.1)",
                            padding: "5px",
                            border: "1px solid rgba(255, 255, 255, 0.23)",
                          }}
                        >
                          HubSpot Reference: {hubSpotReference}
                        </Box>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Box>

            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey", borderRadius: 4 }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*WG1 List Price (Euros)</label>
                  {absData?.wg1 ? (
                    <TextField
                      value={WG1Price.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })}
                      name="WG1Price"
                      fullWidth
                      variant="outlined"
                      type="text"
                      disabled
                    />
                  ) : (
                    <TextField
                      value={WG1Price.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(
                          /[^\d.]/g,
                          "",
                        );
                        setWG1Price(inputValue);
                      }}
                      name="WG1Price"
                      fullWidth
                      variant="outlined"
                      type="text"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*WG2 List Price (Euros)</label>
                  {absData?.wg2 ? (
                    <TextField
                      value={WG2Price.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })}
                      name="WG2Price"
                      fullWidth
                      variant="outlined"
                      type="text"
                      disabled
                    />
                  ) : (
                    <TextField
                      value={WG2Price.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(
                          /[^\d.]/g,
                          "",
                        );
                        setWG2Price(inputValue);
                      }}
                      name="WG2Price"
                      fullWidth
                      variant="outlined"
                      type="text"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">
                    Total List Price (Euros){" "}
                  </label>
                  <Box
                    sx={{
                      padding: "4px 10px",
                      borderRadius: "4px",
                      background: "rgb(255, 255, 255, 0.1)",
                      border: "1px solid rgba(255, 255, 255, 0.23)",
                    }}
                  >
                    {totalListPrice()}
                  </Box>
                </Grid>
                {orderCategoryValue?.value !== "PRJ" &&
                  orderCategoryValue?.value !== "CPRJ" && (
                    <Grid item xs={8}>
                      <label className="pb-8 block">
                        Any special discount agreed?
                      </label>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>No</Typography>
                        <AntSwitch
                          checked={discountChecked}
                          onChange={handleSpecialDicount}
                        />
                        <Typography>Yes</Typography>
                        {discountChecked && (
                          <ColorButton
                            variant="contained"
                            component="label"
                            disabled={SDFile}
                          >
                            <FuseSvgIcon
                              size={16}
                              sx={{ display: "inline-block" }}
                            >
                              heroicons-outline:upload
                            </FuseSvgIcon>{" "}
                            Upload
                            <input
                              type="file"
                              className="file"
                              onChange={handleSDUpload}
                              key={key}
                              ref={hiddenDicountFile}
                              disabled={SDFile}
                            />
                          </ColorButton>
                        )}
                        {SDFile && (
                          <Box className="mt-16">
                            <Chip
                              label={SDFile.name || SDFile.attachmentName}
                              onDelete={removeSDFile}
                            />
                          </Box>
                        )}
                      </Stack>
                    </Grid>
                  )}
                {orderCategoryValue?.value === "RET" &&
                  newOrderData.hubspotEnabled && (
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Cost in HubSpot</label>
                      <Box
                        sx={{
                          padding: "4px 10px",
                          borderRadius: "4px",
                          background: "rgb(255, 255, 255, 0.1)",
                          border: "1px solid rgba(255, 255, 255, 0.23)",
                        }}
                      >
                        {costOfHubSpot
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                      </Box>
                    </Grid>
                  )}
              </Grid>
            </Box>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey", borderRadius: 4 }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">Container No</label>
                  <TextField
                    value={containerNo}
                    onChange={(e) => setContainerNo(e.target.value)}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    name="containerNo"
                    fullWidth
                    variant="outlined"
                    type="text"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*Loading Week</label>
                  <Select
                    value={loadingWeek}
                    onChange={(event) =>
                      setLoadingWeek({ value: event.value, label: event.label })
                    }
                    name="loadingWeek"
                    options={filterLoadingWeekOptions}
                    styles={customStyles(
                      ((checksubmit && !loadingWeek) ||
                        validError.loadingWeek) &&
                        "#f44336",
                    )}
                    className="w-full"
                    isDisabled={sharedLater}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !loadingWeek
                      ? "This field is required"
                      : validError.loadingWeek}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*Freight</label>
                  <Select
                    value={freight}
                    onChange={(event) =>
                      setFreight({
                        id: event.id,
                        value: event.value,
                        label: event.label,
                      })
                    }
                    name="freight"
                    options={freightOptions}
                    styles={customStyles(
                      ((checksubmit && !freight) || validError.freight) &&
                        "#f44336",
                    )}
                    className="w-full"
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !freight
                      ? "This field is required"
                      : validError.freight}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <label className="pb-8 block">Special Comments</label>
                  <TextField
                    multiline
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    name="comment"
                    fullWidth
                    rows={2}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
      <Container
        component="main"
        maxWidth="md"
        sx={{ py: 3, px: { xs: 2, md: 3 } }}
      >
        <Grid container xs={12} className="mb-16">
          <Grid container xs={12} spacing={1} sx={{ position: "relative" }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <label className="pb-8 flex">*DRW File</label>

                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={DRWFile}
                  >
                    <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                      heroicons-outline:upload
                    </FuseSvgIcon>{" "}
                    Upload
                    <input
                      type="file"
                      className="file"
                      onChange={handleDRWUpload}
                      key={key}
                      ref={hiddenDRWFile}
                      disabled={DRWFile}
                      accept=".drw, .prw"
                    />
                  </ColorButton>
                  {DRWFile && (
                    <Box className="mt-16">
                      <Chip
                        label={DRWFile.name || DRWFile.attachmentName}
                        onDelete={removeDRWFile}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
              <Typography className="text-[#f44336] text-sm ml-14">
                {checksubmit && !DRWFile
                  ? "This field is required"
                  : validError.DRWFile}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <label className="pb-8 flex">*Appliances Detail</label>

                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={appliancesDetail || sharedLater || notApplicable}
                  >
                    <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                      heroicons-outline:upload
                    </FuseSvgIcon>{" "}
                    Upload
                    <input
                      type="file"
                      className="file"
                      key={key}
                      onChange={handleADUpload}
                      ref={hiddenADFile}
                      disabled={
                        appliancesDetail || sharedLater || notApplicable
                      }
                    />
                  </ColorButton>
                  {appliancesDetail && (
                    <Box className="mt-16">
                      <Chip
                        label={
                          appliancesDetail.name ||
                          appliancesDetail.attachmentName
                        }
                        onDelete={removeADFile}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
              <Typography className="text-[#f44336] text-sm ml-14">
                {checksubmit &&
                !(appliancesDetail || sharedLater || notApplicable)
                  ? "This field is required"
                  : validError.appliancesDetail}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sharedLater}
                      onChange={(event) => {
                        setSharedLater(event.target.checked);
                        setNotApplicable(false);
                      }}
                    />
                  }
                  label="Will be shared later"
                  sx={{ "& span": { fontSize: "11px" } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={notApplicable}
                      onChange={(event) => {
                        setNotApplicable(event.target.checked);
                        setSharedLater(false);
                      }}
                    />
                  }
                  label="NA"
                  sx={{ "& span": { fontSize: "11px" } }}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <label className="pb-8 flex">*Order Checklist</label>

                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={orderCheckFile || drwFileSupersedes}
                  >
                    <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                      heroicons-outline:upload
                    </FuseSvgIcon>{" "}
                    Upload
                    <input
                      type="file"
                      className="file"
                      key={key}
                      onChange={handleOrderCheckUpload}
                      ref={hiddenOrderCheckFile}
                      disabled={orderCheckFile || drwFileSupersedes}
                    />
                  </ColorButton>
                  {orderCheckFile && (
                    <Box className="mt-16">
                      <Chip
                        label={
                          orderCheckFile.name || orderCheckFile.attachmentName
                        }
                        onDelete={removeOrderCheckFile}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
              <Typography className="text-[#f44336] text-sm ml-14">
                {checksubmit && !(orderCheckFile || drwFileSupersedes)
                  ? "This field is required"
                  : validError.orderCheckFile}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={drwFileSupersedes}
                      onChange={(event) =>
                        setDrwFileSupersedes(event.target.checked)
                      }
                    />
                  }
                  label="DRW file supersedes"
                  sx={{ "& span": { fontSize: "11px" } }}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {uploadValue.map((element, index) => (
                <Card sx={{ position: "relative", mb: 1 }}>
                  <CardContent>
                    <label className="pb-8 flex">Drawing File</label>

                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={
                        uploadValue[index]?.id?.trim().length > 0 ? true : false
                      }
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-outline:upload
                      </FuseSvgIcon>{" "}
                      Upload
                      <input
                        type="file"
                        className="file"
                        key={key}
                        onChange={(event) => handleDrawingUpload(event, index)}
                        ref={hiddenDrawingFile}
                        disabled={
                          uploadValue[index]?.id?.trim().length > 0
                            ? true
                            : false
                        }
                      />
                    </ColorButton>
                    {uploadValue[index]?.uploadFile?.name?.length > 0 && (
                      <Box className="mt-16">
                        <Chip
                          label={
                            uploadValue[index]?.uploadFile?.name ||
                            drawingFile.attachmentName
                          }
                          onDelete={() => removeDrawingFile(index)}
                        />
                      </Box>
                    )}
                  </CardContent>
                  {index ? (
                    <IconButton
                      onClick={() => removeUploadFields(index)}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                      }}
                    >
                      <FuseSvgIcon size={18}>heroicons-outline:x</FuseSvgIcon>
                    </IconButton>
                  ) : null}
                </Card>
              ))}
            </Grid>
            <IconButton
              variant="contained"
              color="secondary"
              onClick={() => addUploadFields()}
              size="small"
              sx={{
                marginRight: { xs: 0, md: "-34px" },
                height: "34px",
                top: { xs: 0, md: "45px" },
                ml: { xs: "auto", md: 0 },
                mt: { xs: 1, md: 0 },
              }}
            >
              <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
            </IconButton>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          p: 2,
          justifyContent: { xs: "stretch", sm: "flex-end" },
          borderTop: "1px solid rgba(241,245,249,.20)",
        }}
      >
        <Button
          fullWidth={isMobile}
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          type="submit"
          sx={{ ml: 1 }}
          disabled={
            btnDisable ||
            clientName.length < 1 ||
            uniqueID.length < 1 ||
            clientName.length + uniqueID.length > 21 ||
            loading
          }
        >
          Place Order
        </Button>
      </Box>

      <OrderSuccess
        open={openSuccessOrder}
        token={token}
        commissionName={commissionName}
        currentOrder={currentOrder}
        setOpenSuccessOrder={setOpenSuccessOrder}
      />
    </>
  );
};

export default CreateAbsOrder;
